<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-6"><a href="#/The_Proud_Sinner2#Contents-A">Epigraph</a></p>
<p class="fp para-style-override-4">Fair is foul, and foul is fair,<br/>Hover through the fog and filthy air.</p>
<p class="body">—Witches, <span class="Italic">Macbeth</span>, Act 1, Scene 1, 1.10-11</p>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// The_Proud_Sinner-5.vue?bdc07ba0